module.exports = __webpack_public_path__ + "static/logo-watermark-a712e3774e02011b9fa430112689eedc.png";